// TODO - Write unit test
import { useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import qs from 'qs'

export function useQuery() {
  const location = useLocation()
  const router = useHistory()

  const query = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  )

  function set(name: string, value: string) {
    const currentParams = toObject()

    // Only update if the value is actually different
    if (currentParams[name] === value) {
      return
    }

    const params = {
      ...currentParams,
      [name]: value,
    }
    const search = qs.stringify(params, { arrayFormat: 'repeat' })
    router.push({ search })
  }

  function setAll(params: { [key: string]: any }) {
    const search = qs.stringify(params, { arrayFormat: 'repeat' })
    router.push({ search })
  }

  function toObject() {
    const obj = {}
    //@ts-ignore
    for (const [key, value] of query.entries()) {
      obj[key] = value
    }
    return obj
  }

  return {
    toObject,
    query,
    set,
    setAll,
  }
}
